import { AbstractPhoneCallGatewayWithHangupFunctionalityStrategy } from 'components/phoneCall/phoneCallGateway/AbstractPhoneCallGatewayWithHangupFunctionalityStrategy';
import { usePhoneCallStore } from 'src/stores/phoneCall';

import { CommandBus } from 'src/util/command/CommandBus';
import { QueryStore } from 'src/util/query/QueryStore';

type PhoneCallStore = ReturnType<typeof usePhoneCallStore>;

export abstract class AbstractPollingPhoneCallGatewayWithHangupFunctionalityStrategy extends AbstractPhoneCallGatewayWithHangupFunctionalityStrategy {
	protected readonly phoneCallStore: PhoneCallStore;
	protected readonly queryStore: QueryStore;
	private loopCounter = 0;

	protected constructor(
		phoneCallStore: PhoneCallStore,
		queryStore: QueryStore,
		commandBus: CommandBus,
		authenticatedUserId: number
	) {
		super(phoneCallStore, commandBus, authenticatedUserId);
		this.phoneCallStore = phoneCallStore;
		this.queryStore = queryStore;
	}

	protected async nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp(
		toNumber: string,
		fromTimestamp: string
	): Promise<null | string> {
		this.loopCounter = 0;
		let nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp: null | number = null;
		while (nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp === null) {
			await this.phoneCallStore.fetchTheNextOutgoingCallIdForACalledNumberAfterAGivenTimestamp({
				number: toNumber,
				queryStore: this.queryStore,
				timestamp: fromTimestamp,
			});

			nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp =
				this.phoneCallStore.nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp;

			this.loopCounter++;
			if (this.loopCounter > 100) {
				break;
			}

			await this.sleep(500);
		}

		return nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp === null
			? null
			: String(nextOutgoingCallIdForACalledNumberAfterAGivenTimestamp);
	}

	private sleep(ms: number): Promise<void> {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve();
			}, ms);
		});
	}
}
